import {
  AdvancedMarker,
  InfoWindow,
  Pin,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";

const LabeledMarker = ({ point }) => {
  const position = {
    lat: parseFloat(point.latitude),
    lng: parseFloat(point.longitude),
  };

  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <>
      <AdvancedMarker position={position} label={point.key} ref={markerRef}>
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Pin background="#4b6fff" borderColor="#336699" glyphColor="#fff" />
          <span
            style={{
              position: "absolute",
              top: "100%",
              marginTop: "6px",
              background: "white",
              padding: "2px 6px",
              borderRadius: "4px",
              fontSize: "12px",
              color: "#333",
              boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
              whiteSpace: "nowrap",
              transform: "translateY(0)",
            }}
          >
            {point.key}
          </span>
        </div>
      </AdvancedMarker>
      {/* <InfoWindow anchor={marker}>{point.key}</InfoWindow> */}
    </>
  );
};

export default LabeledMarker;
